import img1 from "../images/kuubit/img1.jpg";
import img2 from "../images/kuubit/img2.jpg";
import img3 from "../images/kuubit/img3.jpg";
import img4 from "../images/kuubit/img4.jpg";
import img5 from "../images/kuubit/img5.jpg";
import img6 from "../images/kuubit/img6.jpg";

export const imgKuubit = [
  {
    id: 11101,
    image: img1
  },
  {
    id: 11102,
    image: img2
  },
  {
    id: 11103,
    image: img3
  },
  {
    id: 11104,
    image: img4
  },
  {
    id: 11105,
    image: img5
  },
  {
    id: 11106,
    image: img6
  }  
];